import { render, staticRenderFns } from "./ModuleSwap.vue?vue&type=template&id=b257ffae&scoped=true&"
import script from "./ModuleSwap.vue?vue&type=script&lang=js&"
export * from "./ModuleSwap.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSwap.vue?vue&type=style&index=0&id=b257ffae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b257ffae",
  null
  
)

export default component.exports